// The pricing page is a route of this app (see /pricing in App.tsx), not a page on
// the marketing site — so always build the URL against the current origin.
const PRICING_PATH = '/pricing';

export function buildPricingUrl(from?: string) {
  const params = new URLSearchParams();
  if (from) params.set('from', from);
  try {
    const orgId = sessionStorage.getItem('orgId') || '';
    const userId = sessionStorage.getItem('userId') || '';
    if (orgId) params.set('orgId', orgId);
    if (userId) params.set('userId', userId);
  } catch (e) {
    // sessionStorage can be unavailable (private mode / blocked storage) — context params are optional
  }
  const query = params.toString();
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}${PRICING_PATH}${query ? `?${query}` : ''}`;
}

export function openPricing(from?: string) {
  window.open(buildPricingUrl(from), '_blank');
}
